"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _nano = require("./nano");
var _default = exports["default"] = (0, _nano.sheet)({
  grid: {
    display: 'grid',
    padding: '5px',
    margin: '5px 0',
    listStyleType: 'none'
  },
  grid_uniformRows: {
    gridAutoRows: '1fr'
  },
  grid__noItems: {
    display: 'flex'
  }
});